export const WHATSAPP_TEMPLATES = {
    // 1. Consulta general (Botón flotante)
    general: "Hola, necesito información sobre accesorios para mi dispositivo. ¿Me pueden asesorar?",

    // 2. Compra de Producto Disponible
    productAvailable: (productName: string, variantText: string) =>
        `Hola, quiero comprar *${productName}*${variantText}. ¿Cuáles son los métodos y tiempos de envío?`,

    // 3. Consulta de Producto Agotado
    productUnavailable: (productName: string, variantText: string) =>
        `Hola, me interesa *${productName}*${variantText}. Veo que actualmente está agotado. ¿Podrían avisarme cuando vuelva a ingresar inventario?`,

    // 4. Múltiples Productos (Header y Footer de la lista)
    multiProductContext: {
        header: "*NUEVO PEDIDO:*\n\n",
        footer: "\n¿Me confirman disponibilidad y opciones de envío? ¡Gracias!"
    },

    // 5. Solicitud de envío formal
    shippingRequest: {
        header: "*SOLICITUD DE ENVIO*\nHola, envío mi información para procesar mi pedido:\n\n",
        customerInfoHeader: "*DATOS DE ENTREGA:*\n",
        itemsHeader: "\n*ARTICULOS:*",
        footer: "\n¿Me confirman el total con envío? ¡Gracias!"
    }
};
